<template>

    <v-card fluid color="grey darken-4" :height="height">

        <v-tabs v-model="tabModel"
                background-color="grey darken-4"
                hide-slider
                color="white"
                slider-color="#424242"
                active-class="activeTab">

            <v-tab key="dashboard">
                Dashboard
            </v-tab>

            <v-tab key="quotas" v-if="hasFeature('balancing') && project.quotas_enabled">
                Balancing
            </v-tab>

            <v-tab key="geo">
                Geo stats
            </v-tab>

            <v-tab key="suppliers" v-if="hasFeature('project_router_mode') && project.type === 'router'">
                Suppliers
            </v-tab>

            <v-tabs-items v-model="tabModel">

                <!-- BASHBOARD TAB -->
                <v-tab-item key="dashboard" transition="v-fade-transition" reverse-transition="v-fade-transition">

                    <div class="d-flex flex-column align-stretch pl-2 pr-2" :style="'height:' + height + 'px;'">
                        <stat-boxes-project class="mb-2 mt-2" :project="project"></stat-boxes-project>
                        <project-activity-chart class="flex-grow-1" :project="project"></project-activity-chart>
                        <stat-boxes-project-details class="mt-2" :project="project"></stat-boxes-project-details>
                        <stat-boxes-project-revenue class="mb-2 mt-2" :project="project"></stat-boxes-project-revenue>
                    </div>
                </v-tab-item>

                <!-- QUOTAS TAB -->
                <v-tab-item v-if="project.quotas_enabled"
                            transition="v-fade-transition"
                            reverse-transition="v-fade-transition">

                    <v-card color="#424242" :height="height" style="overflow-y:auto">
                        <v-card-text>
                            <quota-tree :target-completes="project.target_completes"
                                        mode="runtime"
                                        :project="project">
                            </quota-tree>
                        </v-card-text>
                    </v-card>
                </v-tab-item>

                <!-- GEO STATS -->
                <v-tab-item transition="v-fade-transition"
                            reverse-transition="v-fade-transition">
                        <geo-stats :project="project"></geo-stats>
                </v-tab-item>

                <!-- EXTERNAL SUPPLIERS-->
                <v-tab-item v-if="hasFeature('project_router_mode') && project.type === 'router'"
                            transition="v-fade-transition"
                            reverse-transition="v-fade-transition">
                    <supplier-stats :project="project"></supplier-stats>
                </v-tab-item>

            </v-tabs-items>
        </v-tabs>

        <div class="d-flex justify-end button-box">

            <!-- HELP BUTTON -->
            <v-fab-transition>
                <v-btn
                    class="align-self-center mr-3"
                    color="grey lighten-1"
                    dark
                    small
                    icon
                    @click="helpClicked"
                >
                    <v-tooltip left color="primary">
                        <template v-slot:activator="{ on }">
                            <v-icon v-on="on" medium>mdi-information-outline</v-icon>
                        </template>
                        <span>Show me what all this means</span>
                    </v-tooltip>
                </v-btn>
            </v-fab-transition>

            <!-- CLOSE BUTTON -->
            <v-fab-transition class="align-self-center">
                <v-btn
                    class="align-self-center mr-3"
                    color="red"
                    dark
                    x-small
                    fab
                    @click="close"
                >
                    <v-tooltip left color="primary">
                        <template v-slot:activator="{ on }">
                            <v-icon v-on="on">mdi-close</v-icon>
                        </template>
                        <span>Close</span>
                    </v-tooltip>
                </v-btn>
            </v-fab-transition>

        </div>

        <help v-if="helpDialogModel"
              v-model="helpDialogModel"
              :identifier="helpFile"
        ></help>

    </v-card>

</template>

<script>

import ProjectActivityChart from './ProjectActivityChart';
import StatBoxesProject from './StatBoxesProject';
import StatBoxesProjectDetails from './StatBoxesProjectDetails';
import StatBoxNumerical from '../../../../components/UI/StatBoxNumerical';
import StatBoxesProjectRevenue from "./StatBoxesProjectRevenue";

import Help from '../../../Help/components/index';
import QuotaTree from "../EditProject/QuotaTree";
import VerticalStatusBoxes from "./VerticalStatusBoxes";
import GeoStats from "./GeoStats";
import SupplierStats from "./SupplierStats";

const vuexModule = 'ProjectManager';
const tabHeight = 48;

export default {

    components: {
        SupplierStats,
        GeoStats,
        VerticalStatusBoxes,
        QuotaTree,
        ProjectActivityChart,
        StatBoxesProject,
        StatBoxesProjectDetails,
        StatBoxesProjectRevenue,
        StatBoxNumerical,
        Help
    },

    props: {
        project: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            helpDialogModel: false,
            helpFile: null,
            height: null,
            tabModel: null,
            quotaStats: null,
        }
    },

    methods: {

        helpClicked() {
            if (this.tabModel === 0) this.helpFile = 'project-dashboard';
            if (this.tabModel === 1) this.helpFile = 'project-quota-monitoring';
            if (this.tabModel === 2) this.helpFile = 'project-geo-stats';
            this.helpDialogModel = true;
        },

        close() {
            this.$emit('close');
        },

        handleResize() {
            this.height = window.innerHeight - tabHeight;
        },
    },

    mounted() {
        window.addEventListener('resize', () => {
            this.handleResize();
        });

        this.handleResize();
    },
}
</script>

<style scoped>

.activeTab {
    background-color: #424242;
    font-color: white;
}

.button-box {
    position: absolute;
    top: 0px;
    right: 0px;
    width: 200px;
    height: 48px;
}
</style>

